/**
 * Versión visible de fc-web-app.
 *
 * REGLA DE VERSIONADO: se incrementa en 1 por cada MR mergeado. El número sigue
 * el conteo de MRs del proyecto, NO SemVer — por eso `package.json` queda
 * congelado en su valor histórico (ver CHANGELOG.md) y esta constante es la
 * única fuente de verdad de la versión que ve el usuario.
 *
 * DÓNDE SE SUBE: en un commit sobre `main` después del merge, nunca dentro de
 * la rama del MR. Este archivo no debe aparecer en el diff de un MR de feature.
 *
 * El motivo es el conflicto: si cada rama sube el número, dos ramas abiertas a
 * la vez editan esta misma línea y GitLab deja de poder auto-mergear la segunda.
 * Con varias ramas cortas en vuelo eso pasa siempre. Sacando el bump de la rama
 * el archivo deja de ser superficie de merge y el conflicto desaparece, sin
 * tocar la cadencia.
 *
 * Y la cadencia se mantiene en 1-por-MR a propósito: este número es un
 * identificador de soporte. Se muestra en el pie del login, en el sidebar y en
 * Novedades justamente para saber qué build está corriendo quien reporta algo.
 * Subirlo sólo "cuando el cambio se note" haría que dos builds distintos
 * compartan número, que es lo único que este valor existe para evitar.
 */
export const APP_VERSION = 'v1.437'
